import Vue from 'vue'
// Helper components
import './Component/Helper/HelperComponent';

//Helper for front-end
Vue.component('app-message', require('./Component/Helper/Message/Message').default);
Vue.component('app-submit-button', require('./Component/Helper/Button/SubmitButton').default);
Vue.component('app-cancel-button', require('./Component/Helper/Button/CancelButton').default);
Vue.component('app-back-button', require('./Component/Helper/Button/BackButton').default);
Vue.component('app-default-button', require('./Component/Helper/Button/AddNewButton').default);
Vue.component('app-form-group', require('./Component/Helper/Form/FormGroup').default);
Vue.component('app-form-group-selectable', require('./Component/Helper/Form/FormGroupSelectable').default);

//Login
Vue.component('app-auth-login', require('./Component/Views/Auth/Login').default);
Vue.component('app-user-profile', require('./Component/Views/Auth/Profile').default);
Vue.component('app-password-reset', require('./Component/Views/Auth/Password/PasswordReset').default)
// Vue.component('app-reset-password', require('./Component/Views/Auth/Password/ResetPassword').default)

Vue.component('modal', require('./Component/Helper/Modal/ModalComponent').default);

//Layout
// Vue.component('app-top-navigation-bar', require('./Component/Views/Layout/TopBar').default);
Vue.component('app-setting-layout', require('./Component/Views/Settings/Global/App/SettingLayout').default);
Vue.component('app-brand-setting-layout', require('./Component/Views/Settings/Global/Brand/AppBrandSettingLayout').default);
Vue.component('app-navbar-notification-dropdown', require('./Component/Views/Layout/Components/NotificationsDropdown').default);
Vue.component('app-page-top-section', require('./Component/Helper/PageTopSection/PageTopSection').default);
Vue.component('mailer-app-dashboard', require('./Component/Views/Dashboard/MailerDashboard').default);
Vue.component('app-brand-setting', require('./Component/Views/Settings/BrandSetting/BrandSettingLayout').default);
Vue.component('app-notifications', require('./Component/Views/Auth/Notifications').default);


Vue.component('app-general-settings', require('./Component/Views/Settings/Global/App/Component/GeneralSetting').default)
Vue.component('app-delivery-settings', require('./Component/Views/Settings/Common/DeliverySettings').default)
Vue.component('app-smtp', require('./Component/Views/Settings/Common/Delivery/SMTP').default)
Vue.component('app-ses', require('./Component/Views/Settings/Common/Delivery/AmazonSES').default)
Vue.component('app-mailgun', require('./Component/Views/Settings/Common/Delivery/Mailgun').default)
Vue.component('app-delivery-list', require('./Component/Views/Settings/Common/MailServerLIst').default)
Vue.component('app-notification-template-settings', require('./Component/Views/Settings/Common/NotificationTemplateSettings').default)
Vue.component('app-store-update-notification-templates', require('./Component/Views/Settings/Common/http/StoreUpdateNotificationTemplate').default)
Vue.component('app-all-notification-settings', require('./Component/Views/Settings/Common/NotificationSettings').default)
Vue.component('app-notification-settings', require('./Component/Views/Settings/Common/http/StoreUpdateNotificationSettings').default)
Vue.component('app-brand-privacy', require('./Component/Views/Settings/Global/Brand/Privacy/BrandPrivacy').default)
Vue.component('app-custom-fields', require('./Component/Views/Settings/Global/Brand/CustomField/CustomFields').default)
Vue.component('app-store-update-custom-fields', require('./Component/Views/Settings/Global/Brand/CustomField/StoreUpdateCustomFields').default)
Vue.component('app-mail-template', require('./Component/Views/Settings/Common/http/NotificationTemplate/MailTemplate').default)
Vue.component('app-database-template', require('./Component/Views/Settings/Common/http/NotificationTemplate/DatabaseTemplate').default)
// Vue.component('app-test-mail-modal', require('./Component/Views/Settings/Common/Delivery/TestMailModal').default)
Vue.component('app-test-mail-modal-mailer', require('./Component/Views/Settings/Common/Delivery/TestMailModal').default)
Vue.component('app-cron-job-settings', require('./Component/Views/Settings/Common/CronJobSettings').default)


//Brand Settings
Vue.component('app-brand-delivery-settings', require('./Component/Views/Settings/BrandSetting/Delivery/BrandDeliverySettings').default)
Vue.component('app-brand-custom-fields', require('./Component/Views/Settings/BrandSetting/CustomFields/CustomFields').default)
Vue.component('app-subscriber-api-url', require('./Component/Views/Settings/BrandSetting/SubscriberApi').default);
Vue.component('app-subscriber-web-form', require('./Component/Views/Settings/BrandSetting/SubscriberWebForm').default);


//Feature
Vue.component('app-brands', require('./Component/Views/Brand/Brands').default);
Vue.component('app-brand-group', require('./Component/Views/BrandGroup/BrandGroup').default)
Vue.component('app-brand-group-modal', require('./Component/Views/BrandGroup/BrandGroupModal').default)
Vue.component('app-brand-modal', require('./Component/Views/Brand/BrandModal').default);
Vue.component('app-template-settings', require('./Component/Views/Settings/Global/Brand/Template/Templates').default);

//User Role
Vue.component('app-users-roles', require('./Component/Views/UserRoles/Index').default);
Vue.component('app-roles-modal', require('./Component/Views/UserRoles/UI/RolesModal').default);
Vue.component('app-user-modal', require('./Component/Views/UserRoles/UI/UserModal').default);
Vue.component('image-group', require('./Component/Views/UserRoles/UI/ImageGroup').default);
Vue.component('app-user-invite-modal', require('./Component/Views/UserRoles/UI/UserInviteModal').default);
Vue.component('app-user-invite-confirm', require('./Component/Views/Auth/UserInvitationConfirm').default)

//Brands feature

Vue.component('app-campaigns', require('./Component/Views/Campaign/Campaigns').default);
Vue.component('app-campaigns-show', require('./Component/Views/Campaign/Show').default);
Vue.component('app-campaign-create-edit', require('./Component/Views/Campaign/CampaignCreateEdit').default);
Vue.component('app-campaign-details', require('./Component/Views/Campaign/Components/CampaignDetails').default);
Vue.component('app-campaign-delivery', require('./Component/Views/Campaign/Components/CampaignDelivery').default);
Vue.component('app-campaign-audience', require('./Component/Views/Campaign/Components/CampaignAudience').default);
Vue.component('app-campaign-content', require('./Component/Views/Campaign/Components/CampaignContent').default);
Vue.component('app-campaign-confirmation', require('./Component/Views/Campaign/Components/CampaignConfirmation').default);

Vue.component('app-emails', require('./Component/Views/Email/Emails').default);
Vue.component('app-lists-create-edit', require('./Component/Views/List/ListCreateEdit').default);
Vue.component('app-lists-show', require('./Component/Views/List/Show').default);
Vue.component('app-list', require('./Component/Views/List/List').default);
Vue.component('app-segments', require('./Component/Views/Segment/Segments').default);
Vue.component('app-store-update-segment', require('./Component/Views/Segment/StoreUpdateSegment').default);

Vue.component('app-subscribers-wrapper', require('./Component/Views/Subscriber/SubscriberWrapper').default);
Vue.component('app-subscribers', require('./Component/Views/Subscriber/Subscribers').default);
Vue.component('app-subscriber-create-edit', require('./Component/Views/Subscriber/SubscriberCreateEdit').default);
Vue.component('app-import-preview-modal', require('./Component/Views/Subscriber/Components/ImportPreviewModal').default);
Vue.component('app-blacklisted-subscribers', require('./Component/Views/Subscriber/BlackListedSubscribers').default);
Vue.component('app-subscriber-import', require('./Component/Views/Subscriber/Import').default);
Vue.component('app-unsubscribe', require('./Component/Views/Subscriber/UnSubscribe').default);

Vue.component('app-brand-templates', require('./Component/Views/Template/Templates').default);
Vue.component('app-template-create-edit', require('./Component/Views/Template/TemplateCreateEdit').default);
Vue.component('app-template-card-view', require('./Component/Views/Template/TemplateCard').default);
Vue.component('app-template-preview-modal', require('./Component/Views/Template/UI/TemplatePreviewModal').default);
Vue.component('app-template-choose-modal', require('./Component/Views/Template/UI/ChooseTemplatesModal').default);

Vue.component('app-templates', require('./Component/Views/Template/Templates').default);

// User Profile

Vue.component('app-profile-personal-info', require('./Component/Views/Profile/ProfilePersonalInfo').default);
// Vue.component('app-password-change', require('./Component/Views/Profile/PasswordChange').default);
Vue.component('app-activity', require('./Component/Views/Profile/Activity').default);
Vue.component('app-user-media', require('./Component/DataTable/Components/User/UserMedia').default);

//Update
Vue.component('app-update', require('./Component/Views/Update/template/Update').default);
Vue.component('app-manual-updater', require('./Component/Views/Update/template/ManualUpdater').default);
Vue.component('app-update-confirmation-modal', require('./Component/Views/Update/template/UpdateConfirmationModal').default);

//Web form
Vue.component('app-web-form-subscriber-create-edit', require('./Component/Views/Subscriber/WebFormSubscriberCreateEdit').default);




// Vue.component('re-captcha', require('./Component/Views/Auth/ReCaptcha').default);

// Notifications
// Vue.component('all-notification', require('./Component/Views/Auth/Notification').default);

// // Profile
// Vue.component('personal-information', require('./Component/Views/Auth/PersonalInformation').default);

// Vue.component('my-profile', require('./Component/Views/Auth/Profile').default);



// App Settings
// Vue.component('email-setting', require('./Component/Views/Settings/AppSettings/EmailSetting').default);
// Vue.component('sms-setting', require('./Component/Views/Settings/AppSettings/SmsSetting').default);
// Vue.component('google-re-captcha-setting', require('./Component/Views/Settings/AppSettings/GoogleRecaptchaSetting').default);
// Vue.component('notification-settings', require('./Component/Views/Settings/AppSettings/Notification/Settings/Index').default);
// Vue.component('database-template', require('./Component/Views/Settings/AppSettings/Notification/Template/DatabaseTemplate').default);
// Vue.component('mail-template', require('./Component/Views/Settings/AppSettings/Notification/Template/MailTemplate').default);
// Vue.component('app-test-mail-modal', require('./Component/Views/Settings/AppSettings/TestMailModal').default)

/**
 * all component of Job point App
 */

// Job Settings - Global
Vue.component('job-setting', require('./Component/Views/Settings/JobSettings/Index').default);
Vue.component('job-type-setting', require('./Component/Views/Settings/JobSettings/Type/JobTypes').default);
Vue.component('job-type-add-edit-modal', require('./Component/Views/Settings/JobSettings/Type/JobTypeAddEditModal').default);
Vue.component('department-setting', require('./Component/Views/Settings/JobSettings/Department/Departments').default);
Vue.component('department-add-edit-modal', require('./Component/Views/Settings/JobSettings/Department/DepartmentAddEditModal').default);
Vue.component('event-type-setting', require('./Component/Views/Settings/JobSettings/EventType/Event').default);
Vue.component('event-add-edit-modal', require('./Component/Views/Settings/JobSettings/EventType/EventTypeAddEditModal').default);
Vue.component('location-setting', require('./Component/Views/Settings/JobSettings/Location/Locations').default);
Vue.component('location-add-edit-modal', require('./Component/Views/Settings/JobSettings/Location/LocationAddEditModal').default);
Vue.component('hiring-stage-setting', require('./Component/Views/Settings/JobSettings/HiringStage/HiringStage').default);
Vue.component('hiring-stage-add-edit-modal', require('./Component/Views/Settings/JobSettings/HiringStage/StageAddEditModal').default);
Vue.component('application-form-setting', require('./Component/Views/Settings/JobSettings/ApplyForm/ApplyForm').default);

// Integration
Vue.component('integrations', require('./Component/Views/Settings/Integrations/Index').default);
Vue.component('zoom-settings', require('./Component/Views/Settings/Integrations/ZoomSettings/ZoomSettings').default);
Vue.component('imap-settings', require('./Component/Views/Settings/Integrations/ImapSetting/ImapSettings').default);

// Dashboard Module
Vue.component('to-do', require('./Component/Views/Dashboard/Todo/Todo').default);
// Vue.component('events', require('./Component/Views/Dashboard/Events/Events').default);
// Vue.component('all-events', require('./Component/Views/Dashboard/Events/AllEvents').default);
// Vue.component('job-grid-view', require('./Component/Views/Dashboard/JobGridView').default);
// Vue.component('job-card', require('./Component/Views/Dashboard/JobCard').default);
// Vue.component('job-add-edit-modal', require('./Component/Views/Dashboard/JobAddEditModal').default);
// Vue.component('shareable-link-modal', require('./Component/Views/Dashboard/ShareableLinkModal').default);
// Vue.component('job-settings', require('./Component/Views/Dashboard/JobSettings/JobSettings').default);
// Vue.component('apply-form-settings', require('./Component/Helper/ApplyForm/ApplyForm').default);
// Vue.component('personal-info-modal', require('./Component/Helper/ApplyForm/PersonalInfoModal').default);
// Vue.component('question-add-edit-modal', require('./Component/Helper/ApplyForm/QuestionAddEditModal').default);
// Vue.component('assignment-add-edit-modal', require('./Component/Helper/ApplyForm/AssignmentAddEditModal').default);
// Vue.component('job-application-form', require('./Component/Views/Dashboard/JobSettings/ApplyFormSetting/ApplicationForm').default);
// Vue.component('job-stages-setting', require('./Component/Views/Dashboard/JobSettings/JobStagesSetting/JobStages').default);
// Vue.component('delete-stage-confirmation', require('./Component/Views/Dashboard/JobSettings/JobStagesSetting/DeleteStageConfirmationModal').default);
// Vue.component('thumbnail-image-setting', require('./Component/Views/Dashboard/JobSettings/ThumbnailImage/JobThumbnail').default);
// Vue.component('hiring-team-setting', require('./Component/Views/Dashboard/JobSettings/HiringTeamSetting/HiringTeamSetting').default);
// Vue.component('hiring-team-add-edit-modal', require('./Component/Views/Dashboard/JobSettings/HiringTeamSetting/HiringTeamAddEditModal').default);
// Vue.component('job-editor', require('./Component/Views/Dashboard/JobEditor').default);
// Vue.component('job-overview', require('./Component/Views/Dashboard/Overview/JobOverview').default);
// Vue.component('overview', require('./Component/Views/Dashboard/Overview/Tabs/Overview').default);
// Vue.component('job-candidates', require('./Component/Views/Dashboard/Overview/Tabs/Candidates').default);

// Candidate Public Module
// Vue.component('candidate-career-page', require('./Component/Views/CareerPage/CandidateCareerPage').default);
// Vue.component('candidate-email-verification-modal', require('./Component/Views/Candidates/Helpers/CandidateEmailVerificationModal').default);
// Vue.component('candidate-application-form', require('./Component/Views/Candidates/CandidateApplicationForm').default);
// Vue.component('candidate-job-post', require('./Component/Views/Dashboard/CandidateJobPost').default);

// Candidate App Module
// Vue.component('candidates', require('./Component/Views/Candidates/Index').default);
// Vue.component('candidate-jobs-expandable-view', require('./Component/Views/Candidates/Helpers/CandidateJobsExpandableView').default);
// Vue.component('candidate-table-star-review', require('./Component/Views/Candidates/Helpers/StarReview').default);
// Vue.component('candidate-details-modal', require('./Component/Views/Candidates/CandidateDetailsModal').default);
// Vue.component('candidate-assign-job-modal', require('./Component/Views/Candidates/CandidateActionsModal/AssignJobModal').default);
// Vue.component('candidate-add-edit-modal', require('./Component/Views/Candidates/CandidateActionsModal/CandidateAddEditModal').default);
// Vue.component('candidate-disqualify-modal', require('./Component/Views/Candidates/CandidateActionsModal/DisqualifyModal').default);
// Vue.component('candidate-mailing-modal', require('./Component/Views/Candidates/CandidateActionsModal/MailingModal').default);
// Vue.component('candidate-event-modal', require('./Component/Views/Candidates/CandidateActionsModal/EventAddEditModal').default);
// Vue.component('career-page', require('./Component/Views/CareerPage/Index').default);
// Vue.component('candidate-status', require('./Component/Views/Candidates/Helpers/CandidateStatus').default);

// Candidate Details Modal Tabs
// Vue.component('candidate-notes', require('./Component/Views/Candidates/Tabs/CandidateNotes').default);
// Vue.component('candidate-details', require('./Component/Views/Candidates/Tabs/CandidateDetails').default);
// Vue.component('candidate-events', require('./Component/Views/Candidates/Tabs/CandidateEvents').default);
// Vue.component('candidate-logs', require('./Component/Views/Candidates/Tabs/CandidateLogs').default);
// Vue.component('candidate-conversation', require('./Component/Views/Candidates/Tabs/CandidateConversation').default);
// Vue.component('candidate-attachments', require('./Component/Views/Candidates/Tabs/CandidateAttachments').default);
// Vue.component('question-answer', require('./Component/Views/Candidates/Tabs/QuestionAnswer').default);
// Vue.component('app-cron-job-settings', require('./Component/Views/Settings/AppSettings/CronJobSetting').default);


//Billar 
Vue.component('payment-method-create-edit-modal', require('./Component/Views/Settings/PaymentMethod/PaymentMethodCreateEditModal').default);

// Clients
Vue.component('clients', require('./Component/Views/Clients/Index').default);
Vue.component('client-details', require('./Component/Views/Clients/ClientDetails').default);
Vue.component('client-add-edit-modal', require('./Component/Views/Clients/ClientAddEditModal').default);
Vue.component('client-address-column', require('./Component/Views/Clients/AddressColumn').default);
Vue.component('client-email-column', require('./Component/Views/Clients/EmailColumn').default);
Vue.component('client-phone-column', require('./Component/Views/Clients/PhoneColumn').default);
Vue.component('address-view-all-modal', require('./Component/Views/Clients/AddressViewAllModal').default);

// Password Manager
Vue.component('password-manager', require('./Component/Views/PasswordManager/Index').default);
Vue.component('password-manager-details', require('./Component/Views/PasswordManager/ClientDetails').default);
Vue.component('password-manager-add-edit-modal', require('./Component/Views/PasswordManager/ClientAddEditModal').default);
Vue.component('password-manager-address-column', require('./Component/Views/PasswordManager/AddressColumn').default);
// Vue.component('client-email-column', require('./Component/Views/Clients/EmailColumn').default);
// Vue.component('client-phone-column', require('./Component/Views/Clients/PhoneColumn').default);

// Quotations
Vue.component('quotation-list', require('./Component/Views/Quotations/List').default);

// Invoices
Vue.component('invoices', require('./Component/Views/Invoices/Index').default);
Vue.component('add-invoice', require('./Component/Views/Invoices/CreateInvoice').default);
Vue.component('invoice-details', require('./Component/Views/Invoices/InvoiceDetails').default);
Vue.component('send-invoice-modal', require('./Component/Views/Invoices/SendInvoiceModal').default);
Vue.component('invoice-add-edit-modal', require('./Component/Views/Invoices/InvoiceAddEditModal').default);
Vue.component('invoice-payment-modal', require('./Component/Views/Invoices/InvoicePaymentModal').default);
Vue.component('stripe-checkout-modal', require('./Component/Views/Invoices/StripeCheckout').default);
Vue.component('recurring-invoice-list', require('./Component/Views/Invoices/RecurringInvoice').default);

// Payments
Vue.component('payments', require('./Component/Views/Payments/Index').default);
Vue.component('payment-add-edit-modal', require('./Component/Views/Payments/PaymentAddEditModal').default);

// Products
Vue.component('products', require('./Component/Views/Products/Index').default);
Vue.component('product-add-edit-modal', require('./Component/Views/Products/ProductAddEditModal').default);
Vue.component('categories', require('./Component/Views/Products/Categories').default);
Vue.component('category-add-edit-modal', require('./Component/Views/Products/CategoryAddEditModal').default);

// Reports
Vue.component('general-summary-report', require('./Component/Views/Reports/GeneralSummaryReport').default);
Vue.component('payment-summary-report', require('./Component/Views/Reports/PaymentSummaryReport').default);
Vue.component('client-statement-report', require('./Component/Views/Reports/ClientStatementReport').default);
Vue.component('invoice-report', require('./Component/Views/Reports/InvoiceReport').default);
Vue.component('expense-report', require('./Component/Views/Reports/ExpenseReport').default);

//Helpers
Vue.component('app-media-column', require('./Component/Helper/MediaColumn').default);

//Expense
Vue.component('app-expense', require('./Component/Views/Expense/Expense').default);
Vue.component('app-expense-create-edit-modal', require('./Component/Views/Expense/ExpenseCreateEditModal').default);
Vue.component('app-attachments-column', require('./Component/Helper/AttachmentsColumn').default);

//purposes
Vue.component('app-purposes', require('./Component/Views/Purposes/Purpose').default);
Vue.component('app-purpose-add-edit-modal', require('./Component/Views/Purposes/PurposeAddEditModal').default);

//Quotation
Vue.component('app-estimates', require('./Component/Views/Estimates/Index').default);
Vue.component('add-estimates', require('./Component/Views/Estimates/CreateEstimates').default);
Vue.component('estimates-details', require('./Component/Views/Estimates/EstimatesDetails').default);
Vue.component('send-estimates-modal', require('./Component/Views/Estimates/SendEstimatesModal').default);
Vue.component('estimates-add-edit-modal', require('./Component/Views/Estimates/EstimatesAddEdit').default);

//Billar Setting
Vue.component('billar-app-setting', require('./Component/Views/Settings/Index').default);
Vue.component('general-setting', require('./Component/Views/Settings/GeneralSetting').default);
Vue.component('email-setting', require('./Component/Views/Settings/EmailSetting').default);
Vue.component('sms-setting', require('./Component/Views/Settings/SmsSetting').default);
Vue.component('google-re-captcha-setting', require('./Component/Views/Settings/GoogleRecaptchaSetting').default);
Vue.component('notification-settings', require('./Component/Views/Settings/Notification/Settings/Index').default);
Vue.component('database-template', require('./Component/Views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./Component/Views/Settings/Notification/Template/MailTemplate').default);
Vue.component('payment-method', require('./Component/Views/Settings/PaymentMethod/PaymentMethod').default);
Vue.component('invoice-setting', require('./Component/Views/Settings/InvoiceSetting').default);
Vue.component('tax-setting', require('./Component/Views/Settings/Tax/Index').default);
Vue.component('tax-add-edit-modal', require('./Component/Views/Settings/Tax/TaxAddEditModal').default);

Vue.component('clear-cache', require('./Component/Views/Settings/ClearCache').default);